import { render } from "./DebitNote.vue?vue&type=template&id=a9070ea0&scoped=true"
import script from "./DebitNote.vue?vue&type=script&lang=js"
export * from "./DebitNote.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=a9070ea0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9070ea0"]])

export default __exports__